import TeacherStatementPage from "./TeacherStatementPage";

export default TeacherStatementPage